import { SET_STEP_VALID } from './../../store/stepper/StepperContext';
import { useCallback, useContext } from 'react';
import {
    SET_CURRENT_STEP,
    SET_STEPS,
    SET_STEP_ACTIVE,
    StepperContext,
} from '../../store/stepper/StepperContext';

export const useStepper = () => {
    const { state, dispatch } = useContext(StepperContext);
    const { currentStep, steps } = state;

    if (!StepperContext) {
        throw new Error('useStepper should be used inside StepperProvider');
    }

    const setCurrentStep = useCallback(
        (currentStep) =>
            dispatch({ type: SET_CURRENT_STEP, payload: { currentStep, steps: state.steps } }),
        [dispatch, state.steps],
    );

    const setSteps = useCallback(
        (steps) => dispatch({ type: SET_STEPS, payload: { steps } }),
        [dispatch],
    );

    const setStepActive = useCallback(
        (currentStep, isActive) =>
            dispatch({
                type: SET_STEP_ACTIVE,
                payload: { currentStep, steps: state.steps, isActive },
            }),
        [dispatch, state.steps],
    );

    const setStepValid = useCallback(
        (currentStep, isValid) =>
            dispatch({
                type: SET_STEP_VALID,
                payload: { currentStep, steps: state.steps, isValid },
            }),
        [dispatch, state.steps],
    );

    return {
        setSteps,
        currentStep,
        setStepActive,
        setStepValid,
        steps,
        setCurrentStep,
    };
};
